import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { t } from '../../utils/helpers';
import MainButton from '@ui-kit/components/mainButton';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { container } from 'tsyringe';
import { ResponseCode, StorageKeys } from '../../utils/constants';
import { UserAuthData, IAuthService } from '@base/features/auth/model/interfaces';
import { ILocalStorage } from '../../features/storage/interfaces';
import { Loader } from '@ui-kit/components/loader';
import PasswordInput from '@ui-kit/components/passwordInput';
import { IModalProvider } from '@base/features/modal/model/interfaces';
import AuthWrapImage from '@base/features/auth/components/authWrapImage';

function ChangePasswordPage() {
  const authService: IAuthService = container.resolve('authService');
  const localStorage: ILocalStorage = container.resolve('localStorage');
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confPassword, setConfPassword] = useState('');

  function handleOldPasswordChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement | null;
    target && setOldPassword(target.value);
  }

  function handlePasswordChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement | null;
    target && setPassword(target.value);
  }

  function handleConfPasswordChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement | null;
    target && setConfPassword(target.value);
  }

  function goToForgotPassword() {
    history.push(MAIN_ROUTES.forgot);
  }

  function changePassword(event: any) {
    event.preventDefault();

    setLoading(true);
    const userAuthData: UserAuthData = localStorage.get(StorageKeys.SESSION);
    const { session } = userAuthData;
    authService
      .changePassword(oldPassword, password, confPassword, session)
      .then((res) => {
        setLoading(false);

        if (res.code === ResponseCode.SUCCESS) {
          modalProvider.show({
            title: t('success'),
            body: t('password_changed_successfully'),
            buttons: [{ title: t('ok'), onClick: () => logout() }],
          });
        } else {
          showChangePasswordModal(res.code);
        }
      })
      .catch(() => {
        setLoading(false);
        modalProvider.show({
          title: t('error'),
          body: 'unknown_error_try_again',
          buttons: [],
        });
      });
  }

  function logout() {
    authService.logout();
    //history.push(PATHS.login);
  }

  function showChangePasswordModal(code: number): void {
    let title = '',
      message = '';
    switch (code) {
      case ResponseCode.SUCCESS: {
        title = 'success';
        message = 'password_changed_successfully';
        break;
      }
      case ResponseCode.OLD_PASSWORD_DO_NOT_MATCH: {
        title = 'Error';
        message = 'old_password_do_not_match';
        break;
      }
      case ResponseCode.BAD_NEW_PASSWORD: {
        title = 'Error';
        message = 'password_6_characters_long';
        break;
      }

      case ResponseCode.PASSWORD_CONFIRMATION_FAILED: {
        title = 'Error';
        message = 'change_password_error2';
        break;
      }

      case ResponseCode.SESSION_EXPIRED: {
        title = 'Error';
        message = 'session_expired_relogin';
        break;
      }
      default: {
        title = 'ERROR';
        message = 'unknown_error_try_again'; //'Unknown error, please try again'
        break;
      }
    }
    modalProvider.show({ title, body: message, buttons: [] });
  }

  const loaderJSX = isLoading && <Loader className="loader-container--black" />;

  return (
    <div className="auth">
      {loaderJSX}
      <AuthWrapImage />
      <div className="register-page">
        <h1 className="forgot-password__title">{t('new_password')}</h1>
        <div className="register-content-wrap">
          <div className="forgot-password">
            <form action="">
              <div className="auth-form-item forgot-password--input-change">
                <PasswordInput
                  className="auth-form-item__text auth-form-item__text--dont-need-valid"
                  placeholder={t('old_password')}
                  id="change-old-password"
                  value={oldPassword}
                  onChange={handleOldPasswordChange}
                />
              </div>

              <div className="auth-form-item forgot-password--input-change">
                <PasswordInput
                  className="auth-form-item__text auth-form-item__text--dont-need-valid"
                  placeholder={t('new_password')}
                  id="change-password"
                  value={password}
                  onChange={handlePasswordChange}
                />
              </div>
              <div className="auth-form-item forgot-password--input-change">
                <PasswordInput
                  className="auth-form-item__text auth-form-item__text--dont-need-valid"
                  placeholder={t('confirm_new_password')}
                  id="change-password-cong"
                  value={confPassword}
                  onChange={handleConfPasswordChange}
                />
              </div>
              <div className="change-password__btn-wrap">
                <MainButton className="change-password__btn" onClick={changePassword}>
                  {t('change_password_title')}
                </MainButton>
                <div className="change-password__btn-cancel-wrap">
                  <MainButton className="change-password__btn-cancel" onClick={goToForgotPassword}>
                    {t('cancel')}
                  </MainButton>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordPage;
